import { getRoute, matchPath } from '@wellesley/router'
import { Bookmark, Settings, Bell } from 'lucide-react'

import { FC } from 'react'
import { LinkItem } from '../../features/links/LinkItem'
import { NotReady } from '../../common/components/NotReady'

export const IconControls: FC = () => (
  <>
    <LinkItem
      key="account"
      isActive={!!matchPath(getRoute('/settings/:tab?'))}
      Icon={Settings}
      link={getRoute('/settings/:tab?', { tab: 'profile' })}
    />

    <NotReady message="Bookmarks are not ready yet">
      <LinkItem
        key="bookmarks"
        isActive={!!matchPath(getRoute('/'))}
        Icon={Bookmark}
        link={getRoute('/')}
      />
    </NotReady>

    <NotReady message="Notifications are not ready yet">
      <LinkItem
        key="notifications"
        isActive={!!matchPath(getRoute('/'))}
        Icon={Bell}
        link={getRoute('/')}
        hasNotification
        variant="notification"
      />
    </NotReady>
  </>
)
